<app-dossier
  eyebrow="Dossier opération // Suivi public"
  stamp="Diffusion restreinte"
  [decor]="false"
>
  @if (operation.value(); as operation) {
    <app-page-title [title]="operation.codeName" [lede]="null" />
    <p class="lede center">
      @switch (operation.statusCode) {
        @case ('VALIDATED') {
          @if (operation.startsAt) {
            Lancement prévu le {{ operation.startsAt | date: "d MMMM 'à' HH 'h' mm" }}
          } @else {
            En attente du lancement
          }
        }
        @case ('COMPLETE') {
          Terminée le {{ operation.completedAt | date: "d MMMM 'à' HH 'h' mm" }}
        }
        @default {
          @if (operation.startsAt) {
            Lancée le {{ operation.startsAt | date: "d MMMM 'à' HH 'h' mm" }}
          }
        }
      }
    </p>

    @if (operation.statusCode === 'VALIDATED' && operation.startsAt) {
      <div class="spaced">
        <app-countdown [until]="operation.startsAt" label="Lancement prévu dans" />
      </div>
    }

    <div class="spaced">
      <app-game-status
        [status]="status()"
        [counts]="counts()"
        [lobby]="operation.statusCode === 'VALIDATED'"
        [done]="operation.statusCode === 'COMPLETE'"
      >
        @switch (operation.statusCode) {
          @case ('VALIDATED') {
            Le recrutement est ouvert.
          }
          @case ('COMPLETE') {
            @if (operation.winner; as winner) {
              Victoire de l'agent {{ agentName(winner) }}.
            }
          }
          @default {
            La traque est ouverte. Le classement se met à jour à chaque élimination validée.
          }
        }
      </app-game-status>
    </div>

    @if (operation.statusCode === 'COMPLETE') {
      <p class="spaced">
        <a
          class="button button--primary button--block"
          [routerLink]="['/operations', operation.publicId, 'victory']"
        >
          Consulter le rapport final <span class="button__arrow" aria-hidden="true">›</span>
        </a>
      </p>
    }

    <h2 class="section-label">
      {{
        operation.statusCode === 'VALIDATED'
          ? 'Agents recrutés'
          : operation.statusCode === 'COMPLETE'
            ? 'Classement final'
            : 'Classement provisoire'
      }}
    </h2>
    @if (operation.ranking.length > 0) {
      <section class="card" aria-label="Classement">
        <app-ranking-table [rows]="operation.ranking" />
      </section>
    } @else {
      <app-state-panel
        kind="empty"
        title="Aucun agent recruté"
        message="Les agents apparaîtront ici dès leur inscription."
      />
    }

    <div class="note">
      <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
      <p>Seuls les prénoms et noms de code sont publiés.</p>
      @if (operation.statusCode !== 'COMPLETE') {
        <p class="accent">Le rapport final sera disponible à la fin de l'opération.</p>
      }
    </div>
  } @else if (notFound()) {
    <app-page-title title="Opération" />
    <app-state-panel
      kind="error"
      title="Dossier introuvable"
      message="Ce dossier n'existe pas, ou il n'est pas encore ouvert."
    />
  } @else if (loadError(); as message) {
    <app-page-title title="Opération" />
    <app-state-panel kind="error" title="Transmission impossible" [message]="message">
      <button class="button button--secondary" type="button" (click)="operation.reload()">
        Réessayer
      </button>
    </app-state-panel>
  } @else {
    <app-page-title title="Opération" />
    <app-state-panel kind="loading" title="Ouverture du dossier…" />
  }
</app-dossier>
